import React from "react";
import { NavLink, Route, Switch, Redirect } from "react-router-dom";

import CommentsList from "./CommentsList";
import "../superRide.css";

/**
 * CommentPage - the two review queues.
 *
 * Both tabs are now one CommentsList told which side to show; they used
 * to be a pair of ~870-line files differing only in the resolver names
 * and which field holds the free text.
 */
const CommentPage = () => (
  <div className="superRideShell">
    <nav className="superRideTabs">
      <NavLink
        className="superRideTab"
        activeClassName="isActive"
        to="/superAdmin/evaluations/commentsOnDriver"
      >
        Driver reviews
      </NavLink>
      <NavLink
        className="superRideTab"
        activeClassName="isActive"
        to="/superAdmin/evaluations/commentsOnPassenger"
      >
        Passenger reviews
      </NavLink>
    </nav>

    <Switch>
      <Route
        exact
        path="/superAdmin/evaluations/commentsOnDriver"
        render={() => <CommentsList key="driver" target="driver" />}
      />
      <Route
        exact
        path="/superAdmin/evaluations/commentsOnPassenger"
        render={() => <CommentsList key="passenger" target="passenger" />}
      />
      <Redirect from="/superAdmin/evaluations" to="/superAdmin/evaluations/commentsOnDriver" />
    </Switch>
  </div>
);

export default CommentPage;
